<template>
    <div class="pageController">
        <div class="page">
            <div class="choose top-choose target">
                <img
                    src="http://static.unicornselected.com/59861d60-9991-11e9-b47a-1bd05293100d.png"
                    alt=""
                >
                <div class="text">
                    <div class="t1">{{'独角汇'|language}}</div>
                    <div class="t2">{{'专注于独角兽企业私募股权份额转让的信息平台'|language}}</div>
                    <div class="actions">
                        <div @click.stop="appDownLoad">{{'下载软件'|language}}</div>
                        <div @click.stop="wxlite">{{'独角汇小程序'|language}}</div>
                        <div
                            v-if="!userInstance.user"
                            @click.stop="register"
                        >{{'注册'|language}}</div>
                    </div>
                </div>
            </div>

            <div class="hot target">
                <template v-if='!this.en'>
                    <img
                        class="hot-img"
                        src="http://static.unicornselected.com/FteZL8gnp0Yk8Qchy3Dmjjno6ZpW"
                        alt
                    >
                </template>
                <template v-else>
                    <img
                        class="hot-img"
                        src="http://static.unicornselected.com/09e9d5d0-11af-11ea-b7b6-5f383587248f.png"
                        alt=""
                    >
                </template>
                <div class="hot-content">

                    <div class="left-btn">
                        <i
                            class="iconfont icon-left"
                            @click="prevHandle()"
                        ></i>
                    </div>

                    <div class="swiper-container swiper-no-swiping">
                        <div class="swiper-wrapper">
                            <a
                                class="swiper-slide"
                                @click.stop="hrefShowLogin"
                                :href="hrefOrLogin('/main/detail?id=' + item._id)"
                                :target="userInstance.user ? '_blank' : ''"
                                v-for=" item in companylist_hot"
                                :key='item.id'
                            >
                                <img
                                    class='swiper-img'
                                    :src="item.logo"
                                />
                            </a>
                        </div>
                    </div>

                    <div class="right-btn">
                        <i
                            class="iconfont icon-right"
                            @click="nextHandle()"
                        ></i>
                    </div>
                </div>
            </div>

            <div class="choose choose-1 target">
                <div class="text">
                    <div class="t1">{{'独角兽资讯'|language}}</div>
                    <template v-if='!en'>
                        <div class="t2">专业客观的信息呈现——最新最全独角兽名单、融资估值历史、行业
                            <br>及公司动态。PC端、移动端联动，更加便捷。
                        </div>
                    </template>
                    <template v-else>
                        <div class="t2">Objective information presented professionally
                            – We offer an updated and comprehensive list of unicorn companies, financing history, industry and company dynamics. Connection established between PC and mobile terminals makes info search more efficient.

                        </div>
                    </template>
                </div>
            </div>

            <div class="pc-img1 target">
                <img src="http://static.unicornselected.com/FgPsIfqutNtPKG0aaROllBw30aRX">
            </div>

            <div class="choose choose-2 target">
                <div class="text">
                    <div class="t1 engine">{{'高效撮合'|language}}</div>
                    <template v-if='!en'>
                        <div class="t2">独角兽项目信息展示、平台报价指导、交易意向电子化反馈、客服系
                            <br>统跟踪服务、线上线下专人协同，谈判签约交割平台全程认证保障。
                        </div>
                    </template>
                    <template v-else>
                        <div class="t2">
                            We present real-time unicorn investment information and provide one-stop transaction services,
                            including bid/ask price guidance, transaction intention authentication, KYC and AML preparation, efficient customer service and professional online and offline coordination to facilitate transaction settlement.

                        </div>
                    </template>
                </div>
            </div>

            <div class="pc-img2 target">
                <img src="http://static.unicornselected.com/Ftex8Z61RjDlHMB_moDDZYnI1lKY">
            </div>

            <div class="choose-3 target">
                <div class="text">{{'服务对象'|language}}</div>
                <div class="services-container">
                    <div
                        class="services"
                        v-for="(item, index) in services"
                        :key="index"
                    >
                        <img
                            :src="item.src"
                            alt
                        >
                        <div class="services-text">
                            <span class="title">{{!en?item.title:item.e_title}}</span>
                            <span class="content">{{!en?item.content:item.e_content}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="choose-4 target">
                <div class="text">
                    <div class="t1">{{'为什么选择我们'|language}}？</div>
                    <template v-if="!en">
                        <div class="t2">
                            <span class="text">可靠：对买卖双方全面把控，确保需求/供给真实可靠</span>
                            <span class="text">专业：提供专业的私募股权交易咨询、三方服务对接等</span>
                            <span class="text zhuanye">全套服务</span>
                            <span class="text martop">高效：利用平台算法、流程及专人服务确保高效撮合</span>
                            <span class="text martop">保密：对买卖双方身份及交易细节高度保密</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="t3">
                            <span class="text">Reliable: We ensure the reliability and authenticity of demand and supply by effectively evaluating buyers and sellers.</span>
                            <span class="text">Professional: We provide comprehensive services including professional PE transaction advisory and third-party recommendation.
                            </span>

                            <span class="text martop">Efficient: Efficient matching is made possible by proprietary algorithms, process and tailored services.
                            </span>
                            <span class="text martop">Confidential: Buyer/seller identities and transaction details are under strict confidentiality. </span>
                        </div>
                    </template>
                </div>
                <img src="http://static.unicornselected.com/Fp0CwDPbnHpmOIbsESh51J3UKa55">
            </div>

            <div
                class="choose-5 target"
                :class="[en?'en-desc-points':'']"
            >
                <div class="text">
                    <div class="t1">{{'使用流程'|language}}</div>
                </div>
            </div>

            <div
                class="desc-points target"
                :class="[en?'en-desc-points':'']"
            >
                <div>
                    <img src="http://static.unicornselected.com/be9e5690-0335-11eb-91c5-d550a48abe82.png">
                    <span class="introduce">{{'注册并认证独角汇账户'|language}}</span>
                </div>
                <img src="http://static.unicornselected.com/FmoaRlcH2e4V0JJrsquA3GTMh6WH">
                <div>
                    <img src="http://static.unicornselected.com/bec00f60-0335-11eb-91c5-d550a48abe82.png">
                    <span class="introduce">{{'浏览项目信息'|language}}</span>
                </div>
                <img src="http://static.unicornselected.com/FmoaRlcH2e4V0JJrsquA3GTMh6WH">
                <div>
                    <img src="http://static.unicornselected.com/bee63500-0335-11eb-91c5-d550a48abe82.png">
                    <span class="introduce">{{'提交项目意向'|language}}</span>
                </div>
                <img src="http://static.unicornselected.com/FmoaRlcH2e4V0JJrsquA3GTMh6WH">
                <div>
                    <img src="http://static.unicornselected.com/FhLxaTBWWIZ4TjwECUI8LK3pkUtl">
                    <span class="introduce">{{'平台资料审核及文件签署'|language}}</span>
                </div>
                <img src="http://static.unicornselected.com/FmoaRlcH2e4V0JJrsquA3GTMh6WH">
                <div>
                    <img src="http://static.unicornselected.com/bf2ab810-0335-11eb-91c5-d550a48abe82.png">
                    <span class="introduce">{{'交易洽谈与合同签署'|language}}</span>
                </div>
                <img src="http://static.unicornselected.com/FmoaRlcH2e4V0JJrsquA3GTMh6WH">
                <div>
                    <img src="http://static.unicornselected.com/bf4d5b40-0335-11eb-91c5-d550a48abe82.png">
                    <span class="introduce">{{'完成交割'|language}}</span>
                </div>
            </div>
        </div>

        <bottom class="footer"></bottom>
    </div>
</template>
<script>
import { HttpClient } from '../util/http.js';
import { userInstance } from '../util/user.js';
import { defaultbus } from '../util/bus.js';
import Bottom from '../components/bottom';
import 'swiper/dist/css/swiper.css';
import { setTimeout } from 'timers';
export default {
    props: [],
    components: {
        Bottom,
    },
    data() {
        return {
            userInstance,
            bushow: false,
            companylist_hot: [],
            countSize: 0,
            count: 0,
            chapterNum: 1,
            swiper: null,
            countSize: 0,
            leftBtn: false,
            services: [
                {
                    src:
                        'http://static.unicornselected.com/FmRF_CShnbO3USIldvpVvRWy07CI',
                    title: '投资人',
                    e_title: 'For Investors',
                    content:
                        '为海内外金融机构和超高净值人群提供丰富的独角兽信息与投资机会',
                    e_content:
                        'We provide a broad range of knowledge on unicorn companies and offer investment opportunities to a diverse set of institutional clients and high-net-worth individuals worldwide.',
                },
                {
                    src:
                        'http://static.unicornselected.com/FqS5zjxVdXgNcOAJLAgwumTgIfuk',
                    title: '股东',
                    e_title: 'For Shareholders',
                    content: '为早期投资人、公司高管等提供退出流动性解决方案',
                    e_content:
                        'We provide early stage investors and company executives with liquidity solutions.',
                },
                {
                    src:
                        'http://static.unicornselected.com/FhPCWi1QXOKuuyVawvQ0mHc4vDE3',
                    title: '独角兽公司',
                    e_title: 'For Companies',
                    content: '配合公司设计并执行员工股权流动计划，市场舆情监测',
                    e_content:
                        'We facilitate the design and implementation of company’s ESOP, and monitor market sentiment.',
                },
            ],
        };
    },
    created() {
        this.fetchHot();
    },
    mounted() {
        $(function() {
            $(window).on('load scroll', function() {
                try {
                    $('.target').anisview({
                        animation: 'slideInUp',
                        direction: 'down',
                        repeat: true,
                    });
                } catch (e) {
                    console.log(e);
                }
            });
        });
    },
    methods: {
        // setFadeAnimate() {
        //     var $animatedElements = $(
        //         'p, h1, h2, h3, h4, h5, a, button, small, img, li, blockquote, .mbr-author-name, em, label, input, textarea, .input-group, .iconbox, .btn-social, .mbr-figure, .mbr-map, .mbr-testimonial .card-block, .mbr-price-value, .mbr-price-figure, .dataTable, .dataTables_info, .engine',
        //     )
        //         .not(function() {
        //             return $(this)
        //                 .parents()
        //                 .is(
        //                     '.navbar, .mbr-arrow, footer, .iconbox, .mbr-slider, .mbr-gallery, .mbr-testimonial .card-block, #cookiesdirective, .mbr-wowslider, .accordion, .tab-content, .engine, .extFooter1, #scrollToTop',
        //                 );
        //         })
        //         .addClass('hidden animated');
        //     function getElementOffset(element) {
        //         var top = 0;
        //         do {
        //             top += element.offsetTop || 0;
        //             element = element.offsetParent;
        //         } while (element);
        //         return top;
        //     }
        //     function checkIfInView() {
        //         var window_height = window.innerHeight;
        //         var window_top_position =
        //             document.documentElement.scrollTop ||
        //             document.body.scrollTop;
        //         var window_bottom_position =
        //             window_top_position + window_height - 50;
        //         $.each($animatedElements, function() {
        //             var $element = $(this);
        //             var element = $element[0];
        //             var element_height = element.offsetHeight;
        //             var element_top_position = getElementOffset(element);
        //             var element_bottom_position =
        //                 element_top_position + element_height;
        //             if (
        //                 element_bottom_position >= window_top_position &&
        //                 element_top_position <= window_bottom_position &&
        //                 $element.hasClass('hidden')
        //             ) {
        //                 $element
        //                     .removeClass('hidden')
        //                     .addClass('fadeInUp')
        //                     .one(
        //                         'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
        //                         function() {
        //                             $element.removeClass('animated fadeInUp');
        //                         },
        //                     );
        //             }
        //         });
        //     }
        //     var $window = $(window);
        //     $window.on('scroll resize', checkIfInView);
        //     $window.trigger('scroll');
        // },
        nextHandle() {
            this.swiper.slideNext();
        },
        prevHandle() {
            this.swiper.slidePrev();
        },
        register() {
            if (!userInstance.user) {
                return defaultbus.$emit('toggle-login');
            }
        },
        wxlite() {
            defaultbus.$emit('toggle-wxlite');
        },
        appDownLoad() {
            defaultbus.$emit('app-download');
        },
        // 热门
        async fetchHot() {
            let res = await HttpClient.post('/restful', {
                model: 'Company',
                cond: {
                    hot: true,
                },
            });
            this.countSize = res.result.length;
            this.companylist_hot = res.result;

            this.$nextTick(() => {
                this.swiper = new Swiper('.swiper-container', {
                    slidesPerView: 5,
                    init: true,
                    preventInteractionOnTransition: true,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true,
                    },
                    loop: true,
                });
            });
        },
    },
};
</script>
<style lang="less" scoped>
.pageController {
    width: 100%;
    margin-top: -5px;
    background: #211f20;
    // font-family: '黑体';
    .page {
        width: 1300px;
        height: 3400px;
        background: url('http://static.unicornselected.com/FlxtmnJbU0Vc6GUqqnrkRkEMnHd8');
        background-size: 1300px 3400px;
        background-position: center;
    }
    .three-phone {
        width: 600px;
        margin-top: 100px;
    }
    .choose {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 250px;
        margin-top: 80px;
        img {
            width: 500px;
        }
        .text {
            color: white;
            text-align: left;
            width: 270px;
            .t1 {
                font-size: 32px;
            }
            .t2 {
                margin-top: 10px;
                color: #fff;
                font-size: 10px;
            }
        }
    }
    .top-choose {
        margin-top: 0;
        display: flex;
        // justify-content: center;
        padding-top: 52px;
        > img {
            // display: none;
            width: 287px;
            // height: 692px;
        }
        .text {
            width: 400px;
            .t1 {
                font-size: 35px;
            }
            .t2 {
                width: 500px;
                font-size: 14px;
                margin-top: 20px;
            }
            .actions {
                display: flex;
                margin-top: 58px;
                > div {
                    overflow: hidden;
                    color: #bc242b;
                    border: 2px solid #bc242b;
                    height: 50px;
                    border-radius: 25px;
                    width: 130px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all ease 0.5s;
                    cursor: pointer;
                    &:hover {
                        background: #bc242b;
                        color: white;
                    }
                }
            }
        }
    }
    .choose-1 {
        justify-content: center;
        // margin-top: 100px;
        .text {
            width: 100%;
            text-align: center;
            .t1 {
                font-size: 33px;
            }
            .t2 {
                margin-left: 195px;
                text-align: left;
                color: #fff;
                font-size: 16px;
            }
        }
    }
    .pc-img1 {
        margin-top: 70px;
        img {
            width: 754px;
            height: 279px;
        }
    }
    .choose-2 {
        justify-content: center;
        margin-top: 150px;
        .text {
            width: 100%;
            text-align: center;
            .t1 {
                font-size: 33px;
            }
            .t2 {
                margin-left: 195px;
                text-align: left;
                color: #fff;
                font-size: 16px;
            }
        }
    }

    .pc-img2 {
        margin-top: 25px;
        img {
            height: 385px;
            width: 666px;
        }
    }

    .choose-3 {
        margin: 0 auto;
        margin-top: 50px;
        width: 793px;
        .text {
            text-align: center;
            font-size: 33px;
            color: #fff;
        }
        .services-container {
            margin-top: 25px;
            display: flex;
            .services {
                margin: 10px;
                // position: relative;
                > img {
                    width: 253px;
                    height: 301px;
                }
                .services-text {
                    color: #fff;
                    display: inline-block;
                    width: 240px;
                    padding: 0 10px;
                    height: 75px;
                    overflow: hidden;
                    overflow-y: auto;
                    position: relative;
                    top: -90px;
                    text-align: left;
                    .title {
                        font-size: 23px;
                        display: inline-block;
                    }
                    .content {
                        font-size: 14px;
                        display: inline-block;
                    }
                }
            }
        }
    }
    .choose-4 {
        display: flex;
        align-items: center;
        padding: 0 270px;
        margin-top: 80px;
        img {
            position: relative;
            width: 450px;
        }
        .text {
            color: white;
            text-align: left;
            width: 380px;
            position: relative;
            .t1 {
                position: relative;
                top: -30px;
                font-size: 32px;
            }
            .t2 {
                line-height: 35px;
                color: #fff;
                font-size: 14px;
                .text {
                    display: inline-block;
                }
                .zhuanye {
                    position: relative;
                    left: 42px;
                    top: -11px;
                }
                .martop {
                    position: relative;
                    top: -12px;
                }
            }
            .t3 {
                line-height: 23px;
                color: #fff;
                font-size: 14px;

                .text {
                    position: relative;
                    top: -5px;
                    margin-bottom: 5px;
                    display: inline-block;
                }
            }
        }
    }

    .choose-5 {
        text-align: center;
        margin-top: 140px;
        // width: 100%;
        .text {
            color: white;
            .t1 {
                font-size: 32px;
            }
        }
    }
    .en-desc-points {
        position: relative;
        top: -50px;
    }
    .desc-points {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 800px;
        margin: 30px auto 0;
        > div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            > img {
                background: #37373f;
                width: 75px;
                height: 75px;
                padding: 15px;
                border-radius: 50%;
            }

            .introduce {
                position: relative;
                right: 3px;
                top: 20px;
                color: white;
                display: inline-block;
                width: 85px;
                text-align: center;
                font-size: 14px;
                // height: 0px;
            }
        }
        > img {
            height: 7px;
            // align-self: center;
            margin-top: 32px;
        }
    }
}
.icon-right,
.icon-left {
    font-size: 40px;
}
.hot {
    margin: auto;
    width: 1300px;
    font-size: 20px;
    height: 300px;
    position: relative;
    top: 0px;
    .hot-img {
        height: 40px;
        width: auto;
    }
    .swiper-container {
        width: 900px;
        // background-color: #fff;
        margin-top: 100px;
        height: 120px;
        display: flex;
        align-items: center;
    }
    .swiper-slide {
        border-radius: 50%;
        width: 180px !important;
        height: 180px !important;
        text-align: center;
        font-size: 18px;
    }
    .swiper-img {
        box-sizing: border-box;
        border: 5px solid rgba(167, 159, 159, 0.726);
        border-radius: 50%;
        width: 120px;
        height: 120px;
    }
    .swiper-slide-active {
        width: 180px !important;
        height: 180px !important;
    }
    > img {
        margin-top: 17px;
        margin-bottom: 30px;
        width: 180px;
        // height: 200px;
    }
    > .title {
        color: #fff;
        font-size: 15px;
        position: relative;
        top: -10px;
    }
    .hot-content {
        position: relative;
        top: -70px;
        left: 20px;
        margin: 0 auto;
        width: 950px;
        overflow: hidden;
        .left-btn {
            cursor: pointer;
            float: left;
            width: 50px;
            position: absolute;
            top: -32px;
            line-height: 370px;
        }
        .right-btn {
            cursor: pointer;
            line-height: 370px;
            position: absolute;
            left: 900px;
            top: -32px;
            float: left;
            width: 50px;
        }
    }
}
</style>
